import { Swiper, Pagination, Navigation, Lazy, Keyboard } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Pagination, Navigation, Lazy, Keyboard]);

export function init_bannerSliders() {
    const SLIDER_BANNERS = document.querySelectorAll('.banner-slider');

    if( SLIDER_BANNERS.length ){
        for( let i=0, len = SLIDER_BANNERS.length; i < len; i++){
            
            new Swiper( SLIDER_BANNERS[i], {
                lazy: {
                    // loadPrevNext: true,
                    loadOnTransitionStart: true,
                },
                keyboard: {
                    enabled: true, onlyInViewport: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                speed: 600,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true 
                },
                
            });
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/banner-sliders.js